import MainMenuStructureElement from 'model/local/main-menu-structure-element'

export default class MainMenuStructure {
  elements: MainMenuStructureElement[]

  constructor (...elements: MainMenuStructureElement[]) {
    this.elements = elements
  }
}
